import { render, staticRenderFns } from "./CaseSubMaintenanceNew.vue?vue&type=template&id=b671d858"
import script from "./CaseSubMaintenanceNew.vue?vue&type=script&lang=js"
export * from "./CaseSubMaintenanceNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports